/* ======================================================================== */
/* 30. grid */
/* ======================================================================== */
var Grid = function ($grid = $('.js-grid')) {

	if (!$grid.length) {
		return;
	}

	var $filter = $grid.parent().find('.js-filter');

	this.masonryGrid = $grid.isotope({
		itemSelector: '.js-grid__item',
		columnWidth: '.js-grid__sizer',
		percentPosition: true
	});

	$grid.imagesLoaded(function () {
		$grid.isotope('layout').one('arrangeComplete', function () {
			if (typeof Waypoint === 'function') {
				Waypoint.refreshAll();
			}
		});
	});

	if ($filter.length) {

		var $filterItems = $filter.find('.js-filter__item');

		$grid.isotope();

		$filterItems.on('click', function (e) {

			e.preventDefault();

			var
				$el = $(this),
				filterBy = $el.data('filter');

			$filterItems.removeClass('filter__item_active');
			$el.addClass('filter__item_active');

			$grid.isotope({
				itemSelector: '.js-grid__item',
				columnWidth: '.js-grid__sizer',
				horizontalOrder: true,
				filter: filterBy
			});

		});

	}

}
